import { Injectable } from '@angular/core';
import { UrlBuilderService } from '../services/url-builder-service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JiraProject } from '../model/jira-project';

@Injectable({
  providedIn: 'root'
})
export class JiraService {


  constructor(
    private urlBuilder: UrlBuilderService,
    private http: HttpClient) {
  }

  getProjects(): Observable<JiraProject[]> {
    return this.http.get<JiraProject[]>(this.urlBuilder.buildUrl('jira'));
  }
}
